import { useQuery } from "@tanstack/react-query";
import { getAcademicTerm } from "../../api/apiAcademicTerms";
import i18next from "i18next";

export function useGetAcademicTerm(id) {
    const { isLoading, data: academicTerm, error } = useQuery({
        queryKey: ["academicTerms", id, i18next.language],
        queryFn: () => getAcademicTerm(id),
        enabled: !!id,
        retry: false,
    });

    return { isLoading, error, academicTerm };
}
